module.exports = __webpack_public_path__ + "no-pic.png?d2e344b45e2d694f4f6b64c86d6897a6";